import styled from 'styled-components';

const FILLED_SPACE = 144;
const METRIC_FILTER_HEIGHT = 80;
const HEADLINE_HEIGHT = 54;

export const TelemetryTabWrapper = styled.div`
  height: calc(100dvh - ${FILLED_SPACE}px);
  display: flex;
  flex-direction: column;
  background: #fff;

  @media screen and (max-width: 576px) {
    overflow-x: hidden;
    overflow-y: auto;
  }
`;

export const MainWrapper = styled.div`
  display: flex;
  border-top: solid 1px #dcdbdc;
  flex-grow: 1;

  @media screen and (max-width: 576px) {
    flex-direction: column;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  padding: 0 10px;
  margin-bottom: -10px;
`;

export const LeftColumn = styled.div`
  border-right: solid 1px #dcdbdc;
  flex-basis: 350px;
  padding: 20px 10px 10px 10px;

  @media screen and (max-width: 576px) {
    flex-basis: unset;
    border-bottom: 1px solid #ccc;
  }
`;

export const MainColumn = styled.div`
  flex-grow: 1;
  padding: 20px 15px;
  flex-direction: column;
  overflow-y: auto;
  height: calc(100dvh - ${FILLED_SPACE + HEADLINE_HEIGHT + METRIC_FILTER_HEIGHT + 20}px);

  @media (max-width: 1224px) {
    height: calc(100dvh - ${FILLED_SPACE + HEADLINE_HEIGHT + METRIC_FILTER_HEIGHT + 120}px);
  }

  @media screen and (max-width: 576px) {
    padding: 1em;
    height: auto;
    overflow-x: auto;
    overflow-y: unset;
  }
`;

export const MetricGraphsContainer = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  flex-direction: column;
`;
